export default __webpack_public_path__ + "static/media/icon-drone.71c78f27.png";